// @flow

// Types
import type {
  Asset,
  AssetsById,
} from 'fc-model-assets/types'

// Constants
import {
  FARM,
  PROP_CATEGORY,
} from 'fc-model-assets'

// Libs
import { createSelector } from 'reselect'
import _reduce from 'lodash/reduce'
import _filter from 'lodash/filter'

// Selectors
import { assets$ } from 'fc-assets'

export const farmsById = createSelector(
  [assets$],
  function (assets: AssetsById): Array<Asset> {
    console.warn('Recompute farms by id')
    return _reduce(
      _filter(assets, (asset: Asset): Array<Asset> => asset[PROP_CATEGORY] === FARM),
      (acc: object, asset: Asset): Object => {
        acc[asset.id] = asset
        return acc
      },
      {})
  }
)

export default createSelector(
  [assets$],
  function (assets: AssetsById): Array<Asset> {
    console.warn('Recompute farms array')
    return _filter(assets, function (asset: Asset): boolean {
      return asset[PROP_CATEGORY] === FARM
    })
  }
)
